import { sortTLOSValue } from '@/features/PatientWorkQueue/utils/sortTLOSValue';

import { TotalLOSRenderer } from '../../CellRendererComponents';
import { UpdatedTotalLOSRenderer } from '../../CellRendererComponents/updatedTotalLOSRenderer';

export const getTotalLosColumnDef = (enableLOSDecimal: boolean) => ({
  id: 'total_los',
  accessor: enableLOSDecimal ? 'tlos' : 'total_length_of_stay',
  Header: 'Total LOS',
  filterable: false,
  sortMethod: enableLOSDecimal ? sortTLOSValue : undefined,
  width: 150,
  Cell: enableLOSDecimal ? UpdatedTotalLOSRenderer : TotalLOSRenderer,
});
